import { createRouter, createWebHashHistory } from 'vue-router'
import { h, defineComponent } from 'vue'
import Home from '../views/Home.vue'
import ViewPost from '../views/ViewPost.vue'
import ViewTag from '../views/ViewTag.vue'
import About from '../views/About.vue'
import ViewTags from '../views/ViewTags.vue'
import ViewProjects from '../views/ViewProjects.vue'
import Links from '../views/Links.vue'
import ViewPosts from '../views/ViewPosts.vue'
import NotFound from '../views/errors/NotFound.vue'
import MarkdownView from '../components/MarkdownView.vue'

const children = []

let Posts = null
try {
  Posts = require('@/../posts/data/posts.json')
} catch (e) {
  Posts = require('@/defaults/posts.json')
}

// Markdown 文章作为子路由:动态 import .md(frontmatter-markdown-loader Mode.HTML
// 产出 { html, attributes }),通过 MarkdownView wrapper 用 v-html 渲染
function makeMarkdownComponent (html) {
  return defineComponent({
    name: 'MarkdownPost',
    render () {
      return h(MarkdownView, { html })
    }
  })
}

Posts.posts.forEach(post => {
  children.push({
    path: post.id,
    component: async function () {
      const value = await import(`@/../posts/${post.id}.md`).catch(err => {
        console.log(err)
        return null
      })
      if (value && value.html) {
        return makeMarkdownComponent(value.html)
      }
      // fallback:legacy VUE_COMPONENT 模式(理论上 Mode.HTML 下不会走到)
      return value && value.vue && value.vue.component
    }
  })
})

export const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/posts',
    name: 'ViewPosts',
    component: ViewPosts
  },
  {
    path: '/posts',
    name: 'ViewPost',
    component: ViewPost,
    children
  },
  {
    path: '/tags/:tag',
    name: 'ViewTag',
    component: ViewTag
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/tags',
    name: 'ViewTags',
    component: ViewTags
  },
  {
    path: '/projects',
    name: 'ViewProjects',
    component: ViewProjects
  },
  {
    path: '/links',
    name: 'Links',
    component: Links
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
